/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbTypeFinancementGridDto
 */
export interface FcbTypeFinancementGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbTypeFinancementGridDto
     */
    idfinancementType?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbTypeFinancementGridDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbTypeFinancementGridDto
     */
    code?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbTypeFinancementGridDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbTypeFinancementGridDto interface.
 */
export function instanceOfFcbTypeFinancementGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTypeFinancementGridDtoFromJSON(json: any): FcbTypeFinancementGridDto {
    return FcbTypeFinancementGridDtoFromJSONTyped(json, false);
}

export function FcbTypeFinancementGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTypeFinancementGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idfinancementType': !exists(json, 'idfinancementType') ? undefined : json['idfinancementType'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbTypeFinancementGridDtoToJSON(value?: FcbTypeFinancementGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idfinancementType': value.idfinancementType,
        'libelle': value.libelle,
        'code': value.code,
        'actif': value.actif,
    };
}

